'use strict';

/*global app*/
/*global services*/
/*global blockElement*/
/*global unBlockElement*/
/*global updateButtonByPreparationStatus*/
/*global btJobCard*/
/*global resClose*/
/*global resError*/
/*global initialize*/
/*global invokeCallback*/

function JobCardService() {
  this.modal = null;

  this.init();
}

JobCardService.prototype = $.extend({}, {
  constructor: 'JobCardService',

  registerCallbacks: function registerCallbacks() {
    var _this = this;

    $('body').on('click', '.job-card__view-info', function () {
      _this.viewInfo($(this).data('jobcard_rid'), $(this).data('jcoperation_rid'));

      return false;
    });

    $('body').on('click', '.job-card__toggle-preparation', function () {
      _this.togglePreparation($(this));

      return false;
    });

    $('body').on('click', '.job-card__toggle-item-preparation', function () {
      _this.toggleItemPreparation($(this));

      return false;
    });

    $('body').on('click', '.job-card__transfer-note-bulk', function () {
      _this.createBulkTransferNote();

      return false;
    });

    $('body').on('click', '.job-card__info', function () {
      _this.infoJobCard();

      return false;
    });

    $('body').on('click', '.job-card__export', function () {
      _this.exportJobCard($(this).data('jobcard_rid'), $(this).data('quantity'));

      return false;
    });

    $('body').on('click', '.job-card__print-product-serial-number', function () {
      _this.printProductSerialNumber($(this).data('jobcard_rid'), $(this).data('jcoperation_rid'), $(this).data('quantity'));

      return false;
    });

    $('body').on('click', '.job-card__print-fireproof-serial-number', function () {
      _this.printFireproofSerialNumber();

      return false;
    });

    $('body').on('click', '.job-card__view-attachments', function () {
      _this.viewAttachments($(this).data('jobcard_rid'), $(this).data('jcoperation_rid'));

      return false;
    });

    return _this;
  },

  //----------------------------------------------------------------------------

  getJobCardRID: function getJobCardRID() {
    var _this = this;
    return _this.modal.contentDOM().find('.job-card').data('job_card_rid');
  },

  getJCOperationRID: function getJCOperationRID() {
    var _this = this;
    return _this.modal.contentDOM().find('.job-card').data('jcoperation_rid');
  },

  getOperationId: function getOperationId() {
    var _this = this;
    return _this.modal.contentDOM().find('.job-card').data('operation_id');
  },

  viewInfo: function viewInfo(RID, JCOperationRID) {
    var _this = this;

    _this.modal.open({
      height: 'auto',
      width: 'xl',
    });

    _this.modal.block();
    app.get('job_card_view_info', { RID: RID, JCOperationRID: JCOperationRID }, function (res) {
      _this.modal.unBlock();

      if (res.msg === 'SUCCESS') {
        _this.modal.content(res.data.html);

        initialize(_this.modal.contentDOM());
      } else {
        app.viewErrorMessage(res.error);
      }
    });

    return _this;
  },

  togglePreparation: function togglePreparation($btn) {
    var _this = this;

    var parameters = {
      JobCardRID: $btn.data('jobcard_rid'),
      JCOperationRID: $btn.data('jcoperation_rid'),
      PreparationStatus: $btn.data('preparation_status')
    };

    blockElement($btn);
    app.getFormation('job_card:toggle_preparation', parameters, function (res) {
      unBlockElement($btn);

      if (res.msg === 'SUCCESS') {
        updateButtonByPreparationStatus($btn, res.data.JobCardPreparationStatus);

        $('body').trigger('job-card-preparation-toggle', res.data);
      } else if (res.msg === 'NOT_VALID') {
        app.viewWarningMessage();
      } else {
        app.viewErrorMessage(res.error);
      }
    });

    return _this;
  },

  toggleItemPreparation: function toggleItemPreparation($btn) {
    var _this = this;

    var tag = $btn.data('tag');

    var parameters = {
      JobCardRID: $btn.data('jobcard_rid'),
      JCOperationRID: $btn.data('jcoperation_rid'),
      ItemRID: $btn.data('item_rid'),
      ArticleId: $btn.data('article_id'),
      PreparationStatus: $btn.data('preparation_status')
    };

    blockElement($btn);
    app.getFormation('job_card:toggle_item_preparation', parameters, function (res) {
      unBlockElement($btn);

      if (res.msg === 'SUCCESS') {
        res.data.tag = tag;

        updateButtonByPreparationStatus($btn, res.data.PreparationStatus);

        $('body').trigger('job-card-preparation-item-toggle', res.data);
      } else if (res.msg === 'NOT_VALID') {
        app.viewWarningMessage();
      } else {
        app.viewErrorMessage(res.error);
      }
    });

    return _this;
  },

  createBulkTransferNote: function () {
    var _this = this;

    var data = [];

    _this.modal.contentDOM().find('.job-car__item').each(function () {
      var $item = $(this);
      var item = {
        ArticleId: $item.data('article_id'),
        ArticleAbbr: $item.data('article_abbr'),
        ArticleName: $item.data('article_name'),
        ArticleCategoryAbbr: $item.data('article_category_abbr'),
        AltUnit: $item.data('alt_unit'),
        IsAvailable: $item.data('is_available'),
        Quantity: 0,
        Tag: $item.data('tag')
      };

      data.push(item);
    });

    services.get('transfer-note').createBulk(data, _this.getJobCardRID(), _this.getJCOperationRID(), _this.getOperationId());

    return _this;
  },

  infoJobCard: function infoJobCard() {
    var _this = this;

    services.get('job-card-search').search({}, function (data) {
      _this.viewInfo(data.RID, data.JCOperationRID);
    });

    return _this;
  },

  doExportJobCard: function doExportJobCard(jobCardRID, quantity, callback) {
    var _this = this;

    app.getValue({ content: app.t('insert_quantity_stickers_to_print'), value: quantity }, function (quantity) {
      app.getFormation('job_card:export', { JobCardRID: jobCardRID, Quantity: quantity, WorkplaceRID: app.param('workplace_rid') }, function (res) {
        if (res.msg === 'SUCCESS') {
          app.viewSuccessMessage();

          invokeCallback(callback);
        } else {
          app.viewErrorMessage(res.error);
        }
      });
    });

    return _this;
  },

  exportJobCard: function exportJobCard(jobCardRID, quantity) {
    var _this = this;

    if (jobCardRID) {
      return _this.doExportJobCard(jobCardRID, quantity);
    }

    services.get('barcode').scanAndFindBarcode(btJobCard, {}, 0, function (res, data) {
      if (res === resClose) {
        return;
      } else if (res === resError) {
        app.viewErrorMessage(app.t('barcode.not_found'), function () {
          _this.exportJobCard();
        });
      } else {
        _this.doExportJobCard(data.RID, data.QuantityPlan, function () {
          _this.exportJobCard();
        });
      }
    });

    return _this;
  },

  doPrintProductSerialNumber: function doPrintProductSerialNumber(jobCardRID, JCOperationRID, quantity, callback) {
    var _this = this;

    app.getValue({ content: app.t('insert_quantity_stickers_to_print'), value: quantity }, function (quantity) {
      app.getFormation('job_card:print_product_serial_number', { JobCardRID: jobCardRID, JCOperationRID: JCOperationRID, Quantity: quantity, WorkplaceRID: app.param('workplace_rid') }, function (res) {
        if (res.msg === 'SUCCESS') {
          app.viewSuccessMessage();

          invokeCallback(callback);
        } else {
          app.viewErrorMessage(res.error);
        }
      });
    });

    return _this;
  },

  printProductSerialNumber: function printProductSerialNumber(jobCardRID, JCOperationRID, quantity) {
    var _this = this;

    if (jobCardRID) {
      if (app.param('is_required_confirm_of_print_product_serial_number')) {
        return app.confirmHtml(app.t('confirm_print_product_serial_number'), function (ret) {
          if (ret) {
            _this.doPrintProductSerialNumber(jobCardRID, JCOperationRID, quantity);
          }
        });
      } else {
        return _this.doPrintProductSerialNumber(jobCardRID, JCOperationRID, quantity);
      }
    }

    services.get('barcode').scanAndFindBarcode(btJobCard, {}, 0, function (res, data) {
      if (res === resClose) {
        return;
      } else if (res === resError) {
        app.viewErrorMessage(app.t('barcode.not_found'), function () {
          _this.printProductSerialNumber();
        });
      } else {
        _this.doPrintProductSerialNumber(data.RID, 0, data.QuantityPlan, function () {
          _this.printProductSerialNumber();
        });
      }
    });

    return _this;
  },

  doPrintFireproofSerialNumber: function doPrintFireproofSerialNumber(jobCardRID, itemNumber, callback) {
    var _this = this;

    app.getFormation('job_card:print_fireproof_serial_number', { JobCardRID: jobCardRID, ItemNumber: itemNumber, WorkplaceRID: app.param('workplace_rid') }, function (res) {
      if (res.msg === 'SUCCESS') {
        app.viewSuccessMessage();

        invokeCallback(callback);
      } else {
        app.viewErrorMessage(res.error, function () {
          invokeCallback(callback);
        });
      }
    });

    return _this;
  },

  printFireproofSerialNumber: function printFireproofSerialNumber() {
    var _this = this;

    services.get('job-card-search-item').search({ btnTitle: services.get('translator').trans('printer.print') }, function (data) {
      _this.doPrintFireproofSerialNumber(data.RID, data.ItemNumber);
    });

    return _this;
  },

  viewAttachments: function viewAttachments(RID, JCOperationRID) {
    var _this = this;

    _this.modal.open({
      height: 'auto',
      width: 'xl',
    });

    _this.modal.block();
    app.get('job_card_view_attachments', { RID: RID, JCOperationRID: JCOperationRID }, function (res) {
      _this.modal.unBlock();

      if (res.msg === 'SUCCESS') {
        _this.modal.content(res.data.html);

        initialize(_this.modal.contentDOM());
      } else {
        app.viewErrorMessage(res.error);
      }
    });

    return _this;
  },

  //----------------------------------------------------------------------------

  init: function init() {
    var _this = this;

    _this.modal = services.get('modal-job-card');

    _this.registerCallbacks();

    return _this;
  }
});
